import styled from 'styled-components'

export const Wrapper = styled.div<{ image: string }>`
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  height: 670px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 16px;
  box-sizing: border-box;

  &::before {
    border-radius: 20px;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-image: url('${({ image }) => image}');
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 0;
  }

  @media (max-width: 720px) {
    height: 520px;
  }
`

export const ContentWrapper = styled.div`
  background-color: #fac532;
  padding: 40px;
  border-radius: 15px;
  position: absolute;
  bottom: 40px;
  left: 40px;
  z-index: 1;
  width: 494px;
  box-sizing: border-box;
  color: var(--brand-secondary);

  & > h1 {
    z-index: 1;
    position: relative;
    font-size: 20px;
  }

  & > h2 {
    z-index: 1;
    font-size: 42px;
  }

  @media (max-width: 720px) {
    width: calc(100% - 32px);
    left: 50%;
    transform: translateX(-50%);
    padding: 26px 16px;

    & > h1 {
      font-size: 16px;
    }

    & > h2 {
      font-size: 24px;
    }
  }
`

export const LocationWrapper = styled.div`
  display: flex;
  gap: 6px;
  background-color: black;
  color: white;
  padding: 6px;
  border-radius: 4px;
  top: 40px;
  right: 40px;
  position: absolute;

  @media (max-width: 720px) {
    display: none;
  }
`

export const ArrowButton = styled.button`
  border-radius: 64px;
  width: 50px;
  height: 50px;
  background-color: #fac532;
  border: 2px solid white;
  cursor: pointer;
`

export const UnderlineGraphic = styled.div<{ bottomOffset?: string }>`
  position: absolute;
  bottom: ${(props) => props.bottomOffset ?? '-16px'};
  left: 0;
`
